import { useQuery } from 'react-query';

import { workScheduleQueryKeys } from './queryKeys';
import { fetchWorkScheduleAddressDirectory } from './workScheduleApi';

export const useWorkScheduleAddressDirectoryQuery = (
  { companyId, cityId },
  options = {}
) =>
  useQuery(
    workScheduleQueryKeys.addressDirectory(companyId, cityId),
    () => fetchWorkScheduleAddressDirectory({ companyId, cityId }),
    {
      staleTime: Infinity,
      ...options,
      enabled:
        Boolean(companyId) &&
        cityId !== undefined &&
        cityId !== null &&
        options.enabled !== false,
    }
  );
